import {message, Modal} from 'ant-design-vue'
import axios from 'axios'
import router from '@/router'
import {system} from '@/api/system.js'
import {util} from '@/components/utils/util.js'
import QS from 'qs'
import store from '../store/index'
import {DateUtil} from "../components/utils/date_util";

var httpAuth = axios.create({
  baseURL: system.requestBaseUrl + system.authServerName,
  timeout: 3000000
});
var httpCloud = axios.create({
  baseURL: system.requestBaseUrl + system.cloudServerName,
  timeout: 3000000
});
var http = axios.create({
  // baseURL: system.requestBaseUrl,
  timeout: 3000000
});
var httpRegistger = axios.create({//注册时验证码，不用加服务名
  baseURL: system.requestBaseUrl + system.authServerName,
  timeout: 3000000
});
var hTTPExpot = axios.create({
  // 不在此处设置 baseURL；exportExcel 已拼接 requestBaseUrl + cssServerName
  // 若设置 authServerName 为 baseURL，会导致路径被拼成 /ptmbio-auth-server/ptmbio-css-server/...
  baseURL: '',
  timeout: 300000,
  responseType: 'blob',
});

let withCredentials = false;
let ContentType = 'application/json;charset=utf-8';

httpAuth.defaults.withCredentials = withCredentials;
httpAuth.defaults.headers['Content-Type'] = ContentType;

httpCloud.defaults.withCredentials = withCredentials;
httpCloud.defaults.headers['Content-Type'] = ContentType;

http.defaults.withCredentials = withCredentials;
http.defaults.headers['Content-Type'] = ContentType;

httpRegistger.defaults.withCredentials = withCredentials;
httpRegistger.defaults.headers['Content-Type'] = ContentType;

hTTPExpot.defaults.withCredentials = withCredentials;
hTTPExpot.defaults.headers["Content-Type"] = ContentType;

let loadingInstance; //创建Loading 的实例

// 请求拦截器
http.interceptors.request.use(

  config => {
    //验证登录，并将token放入header
    let token = sessionStorage.getItem('access_token');
    // if (!token) {//未登录
    //   //进入登录页
    //   router.push('/login');
    //   return;
    // }
    //var tempToken = "eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2lkIjoiMTQ2NDQ1NjkxMDc2NDg1NTI5NiIsInVzZXJfa2V5IjoiMGI5YTk3MWQtZDgxNi00ZTJjLTkwMzctMTA0MTlmMmNjNTBlIiwidXNlcm5hbWUiOiLoi6Xkvp0ifQ.fnD_HcgS8aCZ4D2_TuslXMiAzWDuE6xX44EHOZqo-sJofA2_ODzftmnAqzfibLATvddMFfnL9wxZvNTq-t0C3Q";
    config.headers['Authorization'] = 'Bearer ' + token;
    // console.log(config);
    showFullScreenLoading()
    return config;
  },
  error => {
    return Promise.error(error);
  }
);

http.interceptors.response.use(
  response => {
    tryHideFullScreenLoading()
    // console.log('response',response);
    // 否则的话抛出错误
    if (response.status === 200) {//
      if (response.headers['token']) {//刷新token
        // console.log(response.headers['token']);
        sessionStorage.setItem('token', response.headers['token']);
      }
      if (response.headers['verifyCode']) {//验证码
        sessionStorage.setItem('verifyCode', response.headers['verifyCode']);
      }
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    tryHideFullScreenLoading()
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401: {
          //删除token
          sessionStorage.removeItem('token');
          let path = router.history.current.path;
          //   console.log('path',path)
          if (path != '/login') {//登录页和初次进首页不需要确认提示
            if (path == '/') {//直接进首页
              router.push('/login');
            } else {
              toLogin("您的登录认证已失效，请重新登录！2秒后将强制刷新。", 2);
            }
          }
          break;
        }

        case 409: { // 强制下线
          //删除token
          sessionStorage.removeItem('token');
          toLoginByEnd();
          break;
        }

        case 403:
          showResponseErrorMessage(error.response, '没有访问权限');
          break;

        // 404请求不存在
        case 404:
          message.error('请求的接口不存在，请联系管理员！');
          // vant.Toast.fail("您访问的网页不存在。");
          break;
        // 其他错误，直接抛出错误提示
        default:
          message.error('请求异常，请联系管理员');
        // vant.Toast.fail(error.response.data.message);
      }
      return Promise.reject(error.response);

    } else {//未知异常。axios 传入的是 Error 对象，不能直接 includes
      let path = router.history.current.path;
      if (path !== '/login') {//登录页和初次进首页不需要确认提示
        var errText = '';
        if (typeof error === 'string') {
          errText = error;
        } else if (error && typeof error.message === 'string') {
          errText = error.message;
        }
        if (errText.indexOf('Network Error') >= 0) {
          message.error("网络连接超时，请稍后再试！");
        } else if (errText.indexOf('timeout') >= 0) {
          message.error("系统接口请求超时，请稍后再试！");
        } else if (errText.indexOf('Request failed with status code') >= 0) {
          message.error("系统接口异常，请稍后再试！");
        }
      }
      return Promise.reject(error);
    }
  });

function toLogin(msg, duration) {
  // Modal.error({
  //   title: '登录认证失效，请重新登录！', content: '', onOk() {
  //     router.push('/login');
  //     location.reload();//强制刷新，防止页面有弹框关不掉
  //   }
  // });
  router.push('/403');
  message.error(msg, duration, function () {
    window.location.href = "/login";
  });
}

// 强制下线
function toLoginByEnd() {
  router.push('/403');
  Modal.error({
    title: '您的帐号已在其他地方登录，您已被强制下线，可尝试重新登录。', content: '', onOk() {
      window.location.href = "/login";
    }
  });
}

function showResponseErrorMessage (response, fallbackMsg) {
  var msg = fallbackMsg || '请求失败';
  if (!response || response.data == null) {
    message.error(msg);
    return;
  }
  var data = response.data;
  if (data instanceof Blob) {
    var reader = new FileReader();
    reader.onload = function () {
      try {
        var json = JSON.parse(reader.result);
        message.error(json.msg || json.message || msg);
      } catch (e) {
        message.error(msg);
      }
    };
    reader.readAsText(data);
    return;
  }
  if (typeof data === 'object') {
    message.error(data.msg || data.message || msg);
    return;
  }
  message.error(String(data) || msg);
}

function resolveExportErrorMessage (error) {
  if (!error) {
    return '导出失败';
  }
  if (typeof error === 'string') {
    return error;
  }
  if (error.msg) {
    return error.msg;
  }
  if (error.message) {
    return error.message;
  }
  if (error.response) {
    var data = error.response.data;
    if (data instanceof Blob) {
      if (error.response.status === 403) {
        return '没有导出权限，请联系管理员分配 as:apply:export 权限';
      }
      return '导出失败(' + error.response.status + ')';
    }
    if (typeof data === 'object' && data) {
      return data.msg || data.message || ('导出失败(' + error.response.status + ')');
    }
    if (typeof data === 'string' && data) {
      return data;
    }
    return '导出失败(' + error.response.status + ')';
  }
  return '导出失败';
}

function parseBlobJsonError (blob) {
  return new Promise(function (resolve) {
    if (!(blob instanceof Blob)) {
      resolve(null);
      return;
    }
    if (blob.type && blob.type.indexOf('json') >= 0) {
      blob.text().then(function (text) {
        try {
          resolve(JSON.parse(text));
        } catch (e) {
          resolve(null);
        }
      }).catch(function () {
        resolve(null);
      });
      return;
    }
    if (blob.size >= 512) {
      resolve(null);
      return;
    }
    blob.text().then(function (text) {
      var t = (text || '').trim();
      if (!t || t.charAt(0) !== '{') {
        resolve(null);
        return;
      }
      try {
        resolve(JSON.parse(t));
      } catch (e) {
        resolve(null);
      }
    }).catch(function () {
      resolve(null);
    });
  });
}

function triggerBlobSave (blob, fileName) {
  var downloadElement = document.createElement('a');
  downloadElement.style.display = 'none';
  var href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  downloadElement.download = fileName;
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
  window.URL.revokeObjectURL(href);
}

function handleBlobDownload (response, fileName) {
  var blob = response && response.data;
  if (!blob) {
    message.error('导出失败：响应为空');
    return Promise.resolve();
  }
  return parseBlobJsonError(blob).then(function (json) {
    if (json && (json.code !== 200 && json.code !== '200')) {
      message.error(json.msg || json.message || '导出失败');
      return;
    }
    triggerBlobSave(blob, fileName);
  });
}

/**
 * axios 默认会把 %5B/%5D 还原成 []，Tomcat 拒绝查询串中的方括号（文件名如肽段修饰 [C5H6O4] 会 400）。
 */
function serializeQueryParams (params) {
  if (!params) {
    return ''
  }
  return Object.keys(params).map(function (key) {
    var val = params[key]
    if (val === undefined || val === null) {
      return ''
    }
    return encodeURIComponent(key) + '=' + encodeURIComponent(String(val))
  }).filter(Boolean).join('&')
}

http.$download = function (url, params, filename, onSuccess, onError) {
  http.get(system.requestBaseUrl + system.cssServerName + url, {
    params: params,
    paramsSerializer: serializeQueryParams,
    responseType: 'blob',
  }).then(function (res) {
    return handleBlobDownload(res, filename);
  }).then(function () {
    if (typeof onSuccess === 'function') {
      onSuccess();
    }
  }).catch(function (err) {
    var errMsg = resolveExportErrorMessage(err);
    message.error(errMsg);
    if (typeof onError === 'function') {
      onError(err);
    } else {
      console.error('导出失败:', err);
    }
  });
};

http.$get = function (url, params) {
  return new Promise((resolve, reject) => {
    http.get(system.requestBaseUrl + system.cssServerName + url, {
        params: params,
        paramsSerializer: serializeQueryParams
      },
      {
        headers: {'Content-Type': 'application/json;charset=utf-8'},
      }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  })
}
http.$delete = function (url, params) {
  return new Promise((resolve, reject) => {
    http.delete(system.requestBaseUrl + system.cssServerName + url, {
        params: params
      },
      {
        headers: {'Content-Type': 'application/json;charset=utf-8'},
      }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  })
}
http.$post = function (url, params, headers_) {
  var headers = headers_ ? {'Content-Type': 'application/json;charset=utf-8'} : headers_;
  return new Promise((resolve, reject) => {
    http.post(system.requestBaseUrl + system.cssServerName + url, params,
      {
        headers: headers,
      }).then(res => {
      resolve(res.data);
    })
      .catch(err => {
        reject(err.data)
      })
  })
}
http.$postForApi = function (url, params, headers_) {
  var headers = headers_ ? {'Content-Type': 'application/json;charset=utf-8'} : headers_;
  return new Promise((resolve, reject) => {
    http.post(system.requestBaseUrl + system.cssApiName + url, params,
      {
        headers: headers,
      }).then(res => {
      resolve(res.data);
    })
      .catch(err => {
        reject(err.data)
      })
  })
}
// $cssApiPost
http.$postForApiByMutipart = function (url, params) {
  var headers = {'Content-Type': 'multipart/form-data'};
  return new Promise((resolve, reject) => {
    http.post(system.requestBaseUrl + system.cssApiName + url, params,
      {
        headers: headers,
      }).then(res => {
      resolve(res.data);
    })
      .catch(err => {
        reject(err.data)
      })
  })
}
http.$put = (url, params) => {
  var headers = {'Content-Type': 'application/json;charset=utf-8'};
  return new Promise((resolve, reject) => {
    http.put(system.requestBaseUrl + system.cssServerName + url, util.transformFormData(params),
      {
        headers: headers,
      }).then(res => {
      resolve(res.data);
    })
      .catch(err => {
        reject(err.data)
      })
  })
}
http.$getForChat = function (url, params) {
  return new Promise((resolve, reject) => {
    http.get(system.requestBaseUrlChat + system.chatServiceName + url, {
        params: params
      },
      {
        headers: {'Content-Type': 'application/json;charset=utf-8'},
      }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  })
}
http.$postForChat = function (url, params, headers_) {
  var headers = headers_ ? {'Content-Type': 'application/json;charset=utf-8'} : headers_;
  return new Promise((resolve, reject) => {
    http.post(system.requestBaseUrlChat + system.chatServiceName + url, params,
      {
        headers: headers,
      }).then(res => {
      resolve(res.data);
    })
      .catch(err => {
        reject(err.data)
      })
  })
}
http.$cloudGet = function (url, params) {
  return new Promise((resolve, reject) => {
    http.get(system.requestBaseUrl + system.cloudServerName + url, {
        params: params
      },
      {
        headers: {'Content-Type': 'application/json;charset=utf-8'},
      }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  })
}
http.$cloudGetCard = function (url, params) {
  return new Promise((resolve, reject) => {
    http.get(system.requestBaseUrl + system.cssServerName + url, {
        params: params
      },
      {
        headers: {'Content-Type': 'application/json;charset=utf-8'},
      }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  })
}
http.$cloudDelete = function (url, params) {
  return new Promise((resolve, reject) => {
    http.delete(system.requestBaseUrl + system.cloudServerName + url, {
        params: params
      },
      {
        headers: {'Content-Type': 'application/json;charset=utf-8'},
      }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  })
}
http.$cloudPost = function (url, params, headers_) {
  var headers = headers_ ? {'Content-Type': 'application/json;charset=utf-8'} : headers_;
  return new Promise((resolve, reject) => {
    http.post(system.requestBaseUrl + system.cloudServerName + url, params,
      {
        headers: headers,
      }).then(res => {
      resolve(res.data);
    })
      .catch(err => {
        reject(err.data)
      })
  })
}
http.$cloudPut = (url, params) => {
  var headers = {'Content-Type': 'application/json;charset=utf-8'};
  return new Promise((resolve, reject) => {
    http.put(system.requestBaseUrl + system.cloudServerName + url, util.transformFormData(params),
      {
        headers: headers,
      }).then(res => {
      resolve(res.data);
    })
      .catch(err => {
        reject(err.data)
      })
  })
}

export function showFullScreenLoading() {
  store.commit('addNum')
}

export function tryHideFullScreenLoading() {
//   console.log('store.state.axiosNum',store.state.publics.axiosNum)
  if (store.state.publics.axiosNum <= 0) {
    return;
  }
  store.commit('ruduceNum')
}

hTTPExpot.interceptors.request.use(
  (config) => {
    var token = sessionStorage.getItem("access_token");
    if (!token) {
      router.push("/login");
      return Promise.reject(new Error('未登录'));
    }
    config.headers["Authorization"] = "Bearer " + token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

hTTPExpot.interceptors.response.use(
  (response) => {
    if (response.status >= 200 && response.status < 300) {
      return Promise.resolve(response);
    }
    return Promise.reject(response);
  },
  (error) => {
    if (error && error.response && error.response.status === 403) {
      showResponseErrorMessage(error.response, '没有访问权限');
    }
    return Promise.reject(error);
  }
);

// 列表信息导出(这里面有三个参数分别是查询条件，后端导出接口地址，文件名)
export const exportExcel = (requireVo, excelUrl, fileName) => {
  return hTTPExpot({
    method: "post",
    url: system.requestBaseUrl + system.cssServerName + excelUrl,
    data: requireVo,
  })
    .then(function (response) {
      return handleBlobDownload(response, fileName);
    })
    .catch(function (error) {
      message.error(resolveExportErrorMessage(error));
    });
};
// 列表信息导出(这里面有三个参数分别是查询条件，后端导出接口地址，文件名)
export const exportExcelGet = (requireVo, excelUrl, fileName) => {
  console.log("requireVo", requireVo);
  return hTTPExpot({
    method: "get",
    url: system.requestBaseUrl + system.cssServerName + excelUrl,
    params: requireVo,
  })
    .then(function (response) {
      return handleBlobDownload(response, fileName);
    })
    .catch(function (error) {
      message.error(resolveExportErrorMessage(error));
    });
};

export {httpAuth, http, httpRegistger, httpCloud}



// WEBPACK FOOTER //
// ./src/api/http.js